module.exports = __webpack_public_path__ + "images/Architect-9fa8f9ab035c39cca0ba12d57d684a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Logos/Architect.png
// module id = 45
// module chunks = 0